import { useEffect, useState } from 'react';

const STORAGE_KEY = 'ptr_launch_deadline';
const DURATION_MS = 24 * 60 * 60 * 1000;

function readDeadline(): number {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = Number.parseInt(stored, 10);
      if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
    }
  } catch {
    /* localStorage no disponible */
  }
  const next = Date.now() + DURATION_MS;
  try {
    window.localStorage.setItem(STORAGE_KEY, String(next));
  } catch {
    /* localStorage no disponible */
  }
  return next;
}

export interface CountdownValue {
  hours: string;
  minutes: string;
  seconds: string;
}

export function useCountdown(): CountdownValue {
  const [deadline] = useState<number>(() => readDeadline());
  const [remaining, setRemaining] = useState<number>(() => Math.max(0, deadline - Date.now()));

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()));
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);

  const totalSeconds = Math.floor(remaining / 1000);
  const pad = (value: number) => String(value).padStart(2, '0');

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60)
  };
}
